import { AlertTriangle } from "lucide-react";

const ErrBox = ({ msg }: { msg: string }) => (
  <div className="flex items-center gap-2.5
                  bg-red-50 border border-red-200 rounded-[10px]
                  px-[18px] py-3.5
                  text-[13px] text-red-800">
    <AlertTriangle size={16} color="#dc2626" strokeWidth={2} className="flex-shrink-0" />
    <span>{msg}</span>
  </div>
);

export default ErrBox;